import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/pixel';
export function PricingSection() {
  return <section className="py-20 px-4 bg-black/60" data-id="element-172">
      <div className="max-w-4xl mx-auto text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-174">
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed" data-id="element-175">
            No te voy a cobrar $455. Ni siquiera la mitad. Sé lo que es empezar
            desde cero en este país.
          </p>

          <div className="mb-8" data-id="element-176">
            <p className="text-gray-400 text-lg mb-4" data-id="element-177">
              Llévatelo TODO hoy por solo:
            </p>
            <div className="flex items-center justify-center gap-6 mb-6" data-id="element-178">
              <span className="text-4xl md:text-5xl text-gray-500 line-through" data-id="element-179">
                $455
              </span>
              <motion.span initial={{
              scale: 0.9
            }} whileInView={{
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} className="text-6xl md:text-8xl font-black text-amber-400" data-id="element-180">
                $17
              </motion.span>
            </div>
            <p className="text-sm text-amber-400 font-semibold" data-id="element-181">USD</p>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="bg-red-900/20 border border-red-500/30 rounded-lg p-6 mb-10" data-id="element-182">
            <p className="text-lg text-gray-200 leading-relaxed" data-id="element-183">
              <span className="font-bold text-red-400" data-id="element-184">
                ¿Por qué tan barato?
              </span>{' '}
              Porque quiero que la mayor cantidad de latinos posible tome
              ventaja de la IA antes de que se vuelva demasiado competitiva.
              Pero ojo,{' '}
              <span className="text-amber-400 font-semibold" data-id="element-185">
                este precio subirá a $147 muy pronto.
              </span>
            </p>
          </motion.div>

          <motion.a href="https://aifreelancegoldmine.com/cart/46344678604961:1" onClick={() => trackAddToCart()} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="relative inline-block bg-gradient-to-r from-amber-500 to-amber-600 text-black font-bold text-lg px-10 py-5 rounded-full shadow-2xl hover:shadow-amber-500/50 transition-all duration-300" data-id="element-186">
            <motion.span animate={{
            opacity: [1, 0.7, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="absolute inset-0 bg-amber-400 rounded-full blur-xl opacity-50" data-id="element-187" />
            <span className="relative" data-id="element-188">
              SÍ, QUIERO EMPEZAR MI GOLDMINE — ACCESO INMEDIATO POR $17
            </span>
          </motion.a>
        </motion.div>
      </div>
    </section>;
}